<template>
  <DataList
    :item-model.sync="itemModel"
    :type-object="$constants.DATA_LISTS.VALID_AMBASSADOR_LIST"
    :label="label"
    :item-text-function="ambassadorFullInfo"
    :is-update-on-start="isUpdateOnStart"
  />
</template>

<script>
import DataList from './DataList.vue';

export default {
  name: 'AmbassadorList',

  components: {
    DataList,
  },

  props: {
    ambassadorModel: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: 'ambassador',
    },
    isUpdateOnStart: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    ambassadorFullInfo(ambassador) {
      let firstNameBlock = ambassador.first_name ? `${ambassador.first_name} ` : '';
      const lastNameBlock = ambassador.last_name ? `${ambassador.last_name} ` : '';

      if (!firstNameBlock && !lastNameBlock) {
        firstNameBlock = ambassador.nickname ? `${ambassador.nickname} ` : '';
      }

      return `${firstNameBlock}${lastNameBlock}(ID: ${ambassador.id})`;
    },
  },

  computed: {
    itemModel: {
      get() {
        return this.ambassadorModel;
      },
      set(val) {
        this.$emit('update:ambassadorModel', val);
      },
    },
  },
};
</script>
